/**
 * @format
 */

import { api } from '@/scripts/api';

export const InvoicesService = {
    getAll(options = {}) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/invoices/?${options}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getByNumber(invoiceId, params) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/invoices/detail/${invoiceId}?${params}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    charge(body) {
        return new Promise((resolve, reject) => {
            const service = '/ms/billing/v1/invoices/charge';
            api.post(service, body).then(resolve).catch(reject);
        });
    },

    paymentmark(invoiceId, body) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/invoices/${invoiceId}/paymentmark`;
            api.put(service, body).then(resolve).catch(reject);
        });
    },

    getPaymentMethod(paymentMethodId, type) {
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/payment-methods/${type}/${paymentMethodId}`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    postExportCsv(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/billing/v1/csv-export/vendor-account/${accountId}/subscriptions`;

            api.post(service, payload).then(resolve).catch(reject);
        });
    }
};
